import { css, polished } from 'jimu-core';
import { buttonSize, buttonVariantStyles } from './button';
import { getBoxStyles } from 'jimu-theme';
function _getBorderWidths(isVertical, isRight) {
    const sideWithWidth = isVertical ? isRight ? 'left' : 'right' : 'bottom';
    return css `${['top', 'bottom', 'left', 'right'].map(side => {
        return sideWithWidth === side ? undefined : `border-${side}-width: 0 !important;`;
    })}`;
}
function getRootStyles(rootVars) {
    return css `
    display: flex;
    flex-wrap: nowrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    ${getBoxStyles(rootVars)}
  `;
}
function getVariantStyles(type, variantVars, isVertical, isRight) {
    var _a, _b, _c, _d;
    const { root, item, size } = variantVars;
    return css `
    .nav-link {
      ${buttonVariantStyles(item)}
      ${buttonSize(size)}
    }
    ${type === 'pills' && css `
      &.nav-pills {
        ${_getBorderWidths(isVertical, isRight)}
      }
    `}
    ${type === 'tabs' && css `
      &.nav-tabs {
        ${_getBorderWidths(isVertical, isRight)}
        .nav-item {
          user-select: none;
          ${!isVertical && css `
            margin-bottom: -${(_a = root === null || root === void 0 ? void 0 : root.border) === null || _a === void 0 ? void 0 : _a.width};
          `}
        }
        .nav-link {
          ${!isVertical && css `
            ${polished.borderRadius('top', root === null || root === void 0 ? void 0 : root.borderRadius)};
            /* &:not(:focus).active { */
            &.active {
              border-bottom-color: transparent !important;
            }
          `}
          &.active,
          &.disabled {
            cursor: default;
          }
        }
        .dropdown-menu {
          margin-top: -${(_b = root === null || root === void 0 ? void 0 : root.border) === null || _b === void 0 ? void 0 : _b.width};
          ${polished.borderRadius('top', 0)}
        }
        ${isVertical
        ? css `
          .nav-item {
            margin-${isRight ? 'left' : 'right'}: -${(_c = root === null || root === void 0 ? void 0 : root.border) === null || _c === void 0 ? void 0 : _c.width};
          }
          .nav-link {
            ${polished.borderRadius(isRight ? 'right' : 'left', root === null || root === void 0 ? void 0 : root.borderRadius)};
          }
        `
        : ''}
      }
    `}
    ${type === 'underline' && css `
      &.nav-underline {
        ${_getBorderWidths(isVertical, isRight)}
        .nav-item {
          ${!isVertical && css `
            margin-bottom: -${(_d = root === null || root === void 0 ? void 0 : root.border) === null || _d === void 0 ? void 0 : _d.width};
          `}
        }
        .nav-link {
          ${_getBorderWidths(isVertical, isRight)}
          &:not(:disabled):not(.disabled):active,
          &[aria-expanded="true"] {
            border-bottom-color: transparent;
          }
          /* ${!isVertical && polished.borderRadius('bottom', 0)} */
        }
        ${isVertical
        ? css `
          .nav-item {
            margin-${isRight ? 'left' : 'right'}: -1px;
          }
          .nav-link {
            /* ${polished.borderRadius(isRight ? 'left' : 'right', 0)} */
            border-${isRight ? 'left' : 'right'}-width: ${item.active.border.width} !important;
          }
        `
        : ''}
      }
    `}
  `;
}
export const navStyles = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const isTabs = props.tabs;
    const isUnderline = props.underline;
    const isPills = props.pills;
    const isfill = props.fill;
    const isJustified = props.justified;
    const isVertical = props.vertical;
    const isRight = props.right;
    const iconPosition = props.iconPosition;
    const type = isUnderline ? 'underline' : (isTabs ? 'tabs' : (isPills ? 'pills' : 'default'));
    const textAlign = props.textAlign;
    const showText = (_a = props.showText) !== null && _a !== void 0 ? _a : true;
    const theme = props.theme;
    const navVars = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.nav;
    const { variants: navVariants } = navVars;
    const mode = props.mode;
    const navVariantVars = (_c = navVariants === null || navVariants === void 0 ? void 0 : navVariants[type]) !== null && _c !== void 0 ? _c : {};
    const navSizeVars = (_d = navVariantVars === null || navVariantVars === void 0 ? void 0 : navVariantVars.size) !== null && _d !== void 0 ? _d : {};
    const gap = (_f = (_e = props.gap) !== null && _e !== void 0 ? _e : navVariantVars.gutter) !== null && _f !== void 0 ? _f : 0;
    const childrenCount = (_g = props.children) === null || _g === void 0 ? void 0 : _g.length;
    return navVars && css `
    ${getRootStyles(navVariantVars === null || navVariantVars === void 0 ? void 0 : navVariantVars.root)}

    .jimu-nav-link-wrapper {
      display: block;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .nav-item {
      > .nav-link {
        width: 100%;
        height: 100%;
      }
    }
    /* Variants: */
    ${getVariantStyles(type, navVariantVars, isVertical, isRight)}

    /* Vertical Mode */
    ${isVertical && css `
      &.vertical {
        .nav-item {
          &,
          > .nav-link {
          width: 100%;
          height: auto;
        }
      }
    `}

    /* Gap between nav items */
    ${gap && (isVertical
        ? css `
      .nav-item + .nav-item {
        margin-top: ${gap};
      }
      .nav-item ul.dropdown-menu-inline {
        margin-top: ${gap};
      }
    `
        : css `
      .nav-item + .nav-item {
        margin-left: ${gap};
      }
    `)}

    /* Text alignment in nav items */
    ${textAlign && css `
      .nav-item, .nav-item .jimu-link {
        text-align: ${textAlign};
        > .btn {
          justify-content: ${textAlign === 'left' ? 'flex-start' : textAlign === 'right' ? 'flex-end' : 'flex-start'};
        }
      }
    `}

    /* Fill */
    ${isfill && css `
      &.nav-fill {
        .nav-item {
          flex: 1 1 ${!isNaN(childrenCount) ? `${100 / childrenCount}%` : 'auto'};
          overflow: auto;
          text-align: ${textAlign || 'center'};
          .nav-link {
            width: 100%;
          }
        }
      }
    `}

    ${isJustified && css `
      &.nav-justified {
        .nav-item {
          flex-basis: 0;
          flex-grow: 1;
          text-align: ${textAlign || 'center'};
        }
      }
    `}

    ${mode === 'toggle' && css `
      &.navbar-nav {
        font-size: large;
        .right-icon.jimu-icon {
          margin-right: unset !important;
          width: 12px;
          height: 12px;
        }
        &.nav-tabs .nav-link.active {
          background-color: unset !important;
        }
      }
      .nav-item {
        .nav-link {
          width: 100%;
          justify-content: space-between;
        }
        + .nav-item {
          margin-left: 0;
        }
      }
      .nav-link {
        display: flex;
        width: 100%;
        justify-content: center;
        + .nav-link {
          margin-left: 0;
        }
      }
    `}

    .jimu-icon,
    .left-icon {
      margin-right: ${showText ? (_h = navVariantVars === null || navVariantVars === void 0 ? void 0 : navVariantVars.icon.spacing) !== null && _h !== void 0 ? _h : '.5rem' : 'unset'};
    }
    .right-icon {
      &,
      &.jimu-icon {
        margin-left: ${showText ? (_j = navVariantVars === null || navVariantVars === void 0 ? void 0 : navVariantVars.icon.spacing) !== null && _j !== void 0 ? _j : '.5rem' : 'unset'};
        margin-right: auto;
      }
    }
    ${iconPosition === 'above' && css `
      display: flex;
      flex-direction: column;
      .jimu-icon {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: ${showText ? (_k = navVariantVars === null || navVariantVars === void 0 ? void 0 : navVariantVars.icon.spacing) !== null && _k !== void 0 ? _k : '.5rem' : 'unset'};
      }
    `}
    .nav-link-caret-btn {
      display: inline-block;
      padding: .3125rem;
      margin: -.3125rem ${navVariantVars.icon.spacing};
      border-radius: 50%;
      transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out; /* $btn-transition */
      background: transparent;
      border: none;
      color: inherit;

      .caret-icon {
        display: block;
        margin-left: 0;
        margin-right: 0;
      }
      &:hover {
        background-color: rgba(0,0,0,0.1);
      }
    }

    ${isVertical && css `
      .nav-link.with-caret {
        position: relative;
        padding-right: ${navSizeVars === null || navSizeVars === void 0 ? void 0 : navSizeVars.paddingX};
        .nav-link-caret-btn {
          position: absolute;
          ${textAlign === 'right' ? `left: ${navSizeVars.paddingX};` : `right: ${navSizeVars.paddingX};`}
          height: 20px;
          width: 20px;
          border-radius: 0;
          top: calc(50% - 10px);
          bottom: calc(50% - 10px);
          padding: 0;
          margin: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
      .nav-link.padding-plus-20 {
        ${textAlign === 'right' ? `padding-left: calc(${navSizeVars.paddingX} + 20px);` : `padding-right: calc(${navSizeVars.paddingX} + 20px);`}
      }
    `}
  `;
};
export const navStyleUtils = { getRootStyles, getVariantStyles };
